import { Components, Theme } from '@mui/material/styles';

export const containerConfigs: Components<Theme>['MuiContainer'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      maxWidth: 401,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),

      [theme.breakpoints.up('sm')]: {
        maxWidth: 369,
        paddingLeft: 0,
        paddingRight: 0,
      },

      [theme.breakpoints.up('md')]: {
        maxWidth: 464,
        paddingLeft: 0,
        paddingRight: 0,
      },

      [theme.breakpoints.up('lg')]: {
        maxWidth: 464,
        paddingLeft: 0,
        paddingRight: 0,
      },

      [theme.breakpoints.up('lg')]: {
        maxWidth: 1128,
      },
    }),
  },
};
